module.exports = __webpack_public_path__ + "img/tasya.19d69896.png";